<div class="copyrightSection">
    <div class="col-md-12 text-center">
        <p>&copy; 2020 Friends' Republic. All Rights Reserved.</p>
        <p class="footer">Designed & Developed by <span><a class="foot" href="https://2bracketsnco.com" target="_blank">2 Brackets &amp; Co.</a></span></p>
    </div>
</div>